import React from 'react'
import { isUser } from '../../Config/isUser'
import { isCompany } from '../../Config/isCompany'

const MainRegisterSection = () => {
  function handleClick(e, type){
    e.preventDefault();
    if(isUser || isCompany){
      alert("Önce çıkış yapınız!");
    }else{
      if(type==='user'){
        window.location.href='/register'
      }else{
        window.location.href='/registerCompany'
      }
    }
  }
  return (
    <div className="jp_register_section_main_wrapper" style={{marginBottom: "50px", marginTop:"-30px"}}>
  <div className="jp_regis_left_side_box_wrapper">
    <div className="jp_regis_left_side_box">
      <img src="images/content/regis_icon.png" alt="icon" />
      <h4>BİYOMEDİKAL MÜHENDİSİ ARIYORUM</h4>
      <p>
      İlanlarınızı Biyomedikal mühendislerine ulaştırmak için
        <br />  Firma/Sağlık Kuruluşu olarak hesap oluşturun
      </p>
      <ul>
        <li>
          <a  style={{fontSize:"14px"}} onClick={(e)=>handleClick(e, "company")}  href="/registerCompany">
            <i className="fa fa-plus-circle" /> &nbsp; Firma/Sağlık Kuruluşu Kaydı
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div className="jp_regis_right_side_box_wrapper">
    <div className="jp_regis_right_img_overlay" />
    <div className="jp_regis_right_side_box">
      <img src="images/content/regis_icon2.png" alt="icon" />
      <h4>İş veya staj arıyorum</h4>
      <p>
      Yeni iş ve staj fırsatları için
        <br /> kişi hesabı oluşturun
      </p>
      <ul>
        <li>
          <a onClick={(e)=>handleClick(e, "user")} href="/register">
            <i className="fa fa-plus-circle" /> &nbsp;Kişi kaydı
          </a>
        </li>
      </ul>
    </div>
    <div className="jp_regis_center_tag_wrapper">
      <p>VEYA</p>
    </div>
  </div>
</div>

  )
}

export default MainRegisterSection